import { render, staticRenderFns } from "./CampaingEmailCalender.vue?vue&type=template&id=5fb32c9c&scoped=true"
import script from "./CampaingEmailCalender.vue?vue&type=script&lang=js"
export * from "./CampaingEmailCalender.vue?vue&type=script&lang=js"
import style0 from "./CampaingEmailCalender.vue?vue&type=style&index=0&id=5fb32c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb32c9c",
  null
  
)

export default component.exports